import { ModalClose } from '@mui/joy';

import { LearnMoreLink } from '@/components/LearnMoreLink';

export function EditorModalHeader({
  title,
  description,
  link,
  readOnly = false,
}: {
  title: string;
  description?: string;
  link?: string;
  readOnly?: boolean;
}) {
  return (
    <div className="flex justify-between">
      {!readOnly && (
        <div className="flex flex-col gap-2">
          <span className="display-sm">{title}</span>
          {(description || link) && (
            <div className="text-xs text-quaternary">
              {description}
              {link && (
                <>
                  {description && ' '}
                  <LearnMoreLink link={link} />
                </>
              )}
            </div>
          )}
        </div>
      )}

      <ModalClose size="sm" />
    </div>
  );
}
